import styled from '@emotion/styled';

export const StyledConfettiImage = styled.img`
  width: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;
